// Copyright (c) 2016 Deere & Company

import {
    closeConfirmSaveModal,
    confirmSaveModal,
    confirmSaveModalForLanguageSettings,
    updateConfirmSaveModalVisibility
} from './confirm-save-modal';
import {
    resetRedIndicator,
    resetYellowIndicator,
    updateRedIndicator,
    updateYellowIndicator
} from './reimbursement-summary-settings';
import {
    resetUserSettings,
    updateUserLanguageSettings,
    updateUserSettings
} from './user';
import {
    toggleAllAccounts,
    updateDealerAccounts,
    updateDealerDisplayFormat
} from './dealer-settings';
import {
    toggleAllClaimStatus,
    updateClaimsNumberOfDays,
    updateClaimsStatus
} from './claims-settings';
import {
    toggleAllClaimTypes,
    updateClaimType,
    updateDbsAutoSubmit
} from './dbs-settings';
import {
    toggleAllPartReturnsStatus,
    updatePartReturnsNumberOfDays,
    updatePartReturnsStatus
} from './part-returns-settings';
import {
    updateCsvSeparator,
    updateGeneralDateFormat,
    updateGeneralDecimalFormat,
    updateGeneralTimeZone
} from './general-settings';
import {readTerritories} from './get-territories';
import {revertLanguageSelection} from './revert-language-selection';
import {updateIsSaved} from './update-is-saved';
import {updateLanguagePrimaryLanguage} from './language-settings';
import {updateNextLocation} from './update-next-location';
import {updateThemePreferredTheme} from './theme-settings';

export default {
    closeConfirmSaveModal,
    confirmSaveModal,
    confirmSaveModalForLanguageSettings,
    readTerritories,
    resetRedIndicator,
    resetUserSettings,
    resetYellowIndicator,
    revertLanguageSelection,
    toggleAllAccounts,
    toggleAllClaimStatus,
    toggleAllClaimTypes,
    toggleAllPartReturnsStatus,
    updateClaimType,
    updateClaimsNumberOfDays,
    updateClaimsStatus,
    updateConfirmSaveModalVisibility,
    updateCsvSeparator,
    updateDbsAutoSubmit,
    updateDealerAccounts,
    updateDealerDisplayFormat,
    updateGeneralDateFormat,
    updateGeneralDecimalFormat,
    updateGeneralTimeZone,
    updateIsSaved,
    updateLanguagePrimaryLanguage,
    updateNextLocation,
    updatePartReturnsNumberOfDays,
    updatePartReturnsStatus,
    updateRedIndicator,
    updateThemePreferredTheme,
    updateUserLanguageSettings,
    updateUserSettings,
    updateYellowIndicator
};



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/index.js